import type { IconDef } from '../types';

export const multiDocument: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M15.3477 4C16.8107 4.00009 17.9999 5.21037 18 6.69922V21.3008C17.9999 22.7896 16.8107 23.9999 15.3477 24H4.65234C3.18933 23.9999 2.00006 22.7896 2 21.3008V6.69922C2.00006 5.21037 3.18933 4.00009 4.65234 4H15.3477ZM4.85059 5.77734C4.42587 5.76782 4.07682 6.10391 4.06738 6.53613L3.68945 21.1377C3.68019 21.5698 4.01088 21.925 4.43555 21.9346L15.1309 22.2227C15.5554 22.232 15.9046 21.896 15.9141 21.4639L16.291 6.8623C16.3003 6.43023 15.9705 6.07513 15.5459 6.06543L4.85059 5.77734ZM18.623 0C20.4874 0 21.9999 1.37414 22 3.06543V17.0391C22 17.5676 21.572 18 21.0488 18C20.5257 18 20.0977 17.5676 20.0977 17.0391V3.06543C20.0975 2.44087 19.422 1.92188 18.623 1.92188H6.95117C6.42802 1.92183 6 1.48948 6 0.960938C6.00005 0.432439 6.42805 4.22348e-05 6.95117 0H18.623Z',
    },
  ],
};
